import React, { Component } from 'react'
import Event1 from '../../assets/image/event1.jpg'
import './style.css'
import whitepaper1 from '../../assets/image/whitepaper/whitepaper1.png'
import Download from '../../assets/image/Download.svg'
// const data_whitepaper=[
//     {img:whitepaper1},
//     {img:whitepaper1},
//     {img:whitepaper1},
//     {img:whitepaper1},
// ]
export default class bulletin extends Component {
    render() {
        const {data}=this.props
        // console.log('op',data)
        return (
            <div>
                <div className='whitepaper-grid'>
                        {data.map((data,i)=>(
                            <div className='whitepaper-overlay'>
                                <img src={data.img}/>
                                <div className='request-copy' onClick={()=>window.open(data.url,'_blank')}>
                                    <div style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
                                    <img src={Download} style={{width:15}}/>
                                    <p>request copy</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
            </div>
        )
    }
}
